import { faEye, faEyeSlash } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import React from "react";

import { Viewer } from "@/mk2/apps/bazaar/constants";
import { BazaarMessageEntity } from "@/mk2/apps/bazaar/schemas";
import { timeAt } from "@/mk2/helpers/timeformat";
import { interpolate } from "@/mk2/services/i18n";
import {
    BZ2_BUYER_HAS_NOT_READ_YET,
    BZ2_BUYER_READ_THE_MESSAGE_ON_date,
    BZ2_BUYER_buyer_HAS_NOT_READ_YET,
    BZ2_BUYER_buyer_READ_THE_MESSAGE_ON_date,
    BZ2_SELLER_HAS_NOT_READ_YET,
    BZ2_SELLER_READ_THE_MESSAGE_ON_date,
    BZ2_SELLER_seller_HAS_NOT_READ_YET,
    BZ2_SELLER_seller_READ_THE_MESSAGE_ON_date,
} from "@/mk/autogenerated/translation";

import styles from "./HasSeen.mscss";

interface OwnProps {
    className?: string;
    message: BazaarMessageEntity;
    viewer: Viewer;
}

type Props = OwnProps;

const HasSeen: React.FunctionComponent<Props> = ({ className, message, viewer }) => {
    let content;
    if (viewer === Viewer.ADMIN) {
        if (message.isSeller) {
            content = message.viewDate
                ? interpolate(BZ2_BUYER_buyer_READ_THE_MESSAGE_ON_date, {
                      buyer: message.buyer.user.username,
                      date: timeAt(message.viewDate),
                  })
                : interpolate(BZ2_BUYER_buyer_HAS_NOT_READ_YET, {
                      buyer: message.buyer.user.username,
                  });
        } else {
            content = message.viewDate
                ? interpolate(BZ2_SELLER_seller_READ_THE_MESSAGE_ON_date, {
                      seller: message.buyer?.product?.seller?.username || message.seller.username,
                      date: timeAt(message.viewDate),
                  })
                : interpolate(BZ2_SELLER_seller_HAS_NOT_READ_YET, {
                      seller: message.buyer?.product?.seller?.username || message.seller.username,
                  });
        }
    } else if (viewer === Viewer.SELLER) {
        if (!message.isSeller) {
            // This is my message - do not display HasSeen
            return null;
        }

        content = message.viewDate
            ? interpolate(BZ2_BUYER_READ_THE_MESSAGE_ON_date, { date: timeAt(message.viewDate) })
            : BZ2_BUYER_HAS_NOT_READ_YET;
    } else {
        if (message.isSeller) {
            // This is my message - do not display HasSeen
            return null;
        }

        content = message.viewDate
            ? interpolate(BZ2_SELLER_READ_THE_MESSAGE_ON_date, { date: timeAt(message.viewDate) })
            : BZ2_SELLER_HAS_NOT_READ_YET;
    }

    return (
        <div className={cx(styles.HasSeen, className)}>
            <FontAwesomeIcon icon={message.viewDate ? faEye : faEyeSlash} /> {content}
        </div>
    );
};

HasSeen.displayName = "HasSeen";

export default React.memo<Props>(HasSeen);
